import ControllerBase from '../../../../global/js/ControllerBase';
import { getCookie, setCookie } from "../../../../global/js/Utils";
import { MoleculeCardProps } from "../../molecules/m-card/m-card.data";
import { Component } from "../../../../global/interfaces/component.interface";
import { t } from 'i18next';

export default class ControllerDownloadList extends ControllerBase {

  private apiUrl;
  private backdrop;
  private basketShown = false;
  private card;
  private cards;
  private close;
  private counter;
  private counterAdded;
  private counterBar;
  private counterBarLast;
  private counterButton;
  private counterTotal;
  private counterWrapper;
  private downloadAll;
  private header;
  private list;
  private listContainer;
  private maxSize;
  private removeAll;

  constructor(element: HTMLElement) {
    super(element);
    this.init();
    this.card = require('components/molecules/m-card/m-card.template.twig') as (data: Component<MoleculeCardProps>,) => string;
  }

  private setRemove() {
    this.cards = this.list.querySelectorAll('.m-card');
    for (const item of this.cards) {
      item.querySelector('.m-card-delete').addEventListener('click', e => {
        const assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]");
        const id = item.getAttribute('data-id');
        const index = assetDownloadList.indexOf(`"${id}"`);
        this.clearById(id);
        let basketSize = parseInt(getCookie('basketSize') || "0");
        basketSize -= parseInt(item.getAttribute('data-size') || "0");
        setCookie('basketSize', 1, `${Math.max(basketSize, 0)}`);
        if (index >= 0) assetDownloadList.splice(index, 1);
        if (assetDownloadList.length < 1) this.closeModal();
        setCookie('assetDownloadList', 1, JSON.stringify(assetDownloadList));
        item.remove();
      });
    }
  }

  private clearById(id) {
    const addIcon = document.querySelector('.js-add-icon');
    const origSvg = addIcon ? addIcon.innerHTML : '+';
    const groupsWithId = document.querySelectorAll(`.m-button-group[data-id="${id}"]`);
    if (groupsWithId.length) {
      for (const group of groupsWithId) {
        group.classList.remove('added-to-list');
        const btn = group.querySelector('[data-download="add-to-donwloadlist"] .a-button__icon-wrapper') as HTMLElement;
        if (btn) btn.innerHTML = origSvg;
      }
    }
  }

  private clearAll() {
    const assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]").map(id => id.replaceAll('"', ''));
    for (const id of assetDownloadList) {
      this.clearById(id);
    }
    setCookie('assetDownloadList', 1, JSON.stringify([]));
    setCookie('basketSize', 1, '0');
    setCookie('lastAdded', 1, '0');
    this.list.innerHTML = '';
    this.closeModal();
  }

  private async downloadAllAssets() {
    let href = this.apiUrl;
    let options = {};
    const assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]").map(id => id.replaceAll('"', ''));
    if (!assetDownloadList.length) return false;
    if (this.apiUrl) {
      options = {
        headers: {
          "Content-Type": "application/json"
        },
        method: 'POST',
        body: JSON.stringify({
          "action": "get-token",
          "documentIds": assetDownloadList,
        })
      };
    } else {
      href = '/downloadAll.json';
    }
    await fetch(href, options)
      .then(response => response.json())
      .then((response) => {
        if (response.data?.['download-token']?.length) {
          const token = response.data['download-token'];
          const downloadUrl = `/download-assets-zipstream/${token}`;
          const a = document.createElement('a');
          a.setAttribute('download', '');
          a.setAttribute('href', downloadUrl);
          a.click();
          this.clearAll();
        }
      })
      .catch(err => console.error(err));
  }

  private async getDownloadList() {
    let content = '';
    let href = this.apiUrl;
    let options = {};
    const assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]").map((id: any) => id.replaceAll('"', ''));
    if (!assetDownloadList.length) return false;
    if (this.apiUrl) {
      options = {
        headers: {
          "Content-Type": "application/json"
        },
        method: 'POST',
        body: JSON.stringify({
          "action": "download-list",
          "documentIds": assetDownloadList
        })
      };
    } else {
      href = '/downloadlist.json';
    }
    await fetch(href, options)
      .then(response => response.json())
      .then((response) => {
        for (const cardObject of response.data.result) {
          content += this.card({ data: cardObject });
        }
        this.list.innerHTML = content;
        this.setRemove();
      })
      .catch((err) => console.error(err))
  }

  private closeModal(): void {
    this.listContainer.setAttribute('data-open', 'false');
    this.list.innerHTML = '';
    document.body?.classList.remove('mediacenter-opened');
  }

  private init(): void {
    this.apiUrl = this.$element.getAttribute('data-api-url');
    this.maxSize = this.$element.getAttribute('data-max-size');
    this.counter = this.$element.querySelector('.download-counter') as HTMLElement;
    this.counterButton = this.$element.querySelector('button') as HTMLElement;
    this.listContainer = this.$element.querySelector('.o-download-list-container-wrapper') as HTMLElement;
    this.list = this.listContainer.querySelector('.o-download-list-items') as HTMLElement;
    this.close = this.listContainer.querySelector('.o-download-list-close') as HTMLElement;
    this.backdrop = this.listContainer.querySelector('.o-download-list-backdrop') as HTMLElement;
    this.counterWrapper = this.$element.querySelector('.counter-wrapper') as HTMLElement;
    this.counterAdded = this.counterWrapper.querySelector('.counter-added') as HTMLElement;
    this.counterTotal = this.counterWrapper.querySelector('.counter-total') as HTMLElement;
    this.counterTotal.innerHTML = this.formatBytes(this.maxSize, 0);
    this.counterBar = this.counterWrapper.querySelector('.counter-bar') as HTMLElement;
    this.counterBarLast = this.counterWrapper.querySelector('.counter-bar-last') as HTMLElement;
    this.downloadAll = this.listContainer.querySelector('.o-download-list-buttons [data-type="download-all"]') as HTMLElement;
    this.removeAll = this.listContainer.querySelector('.o-download-list-buttons [data-type="remove-all"]') as HTMLElement;
    this.removeAll?.addEventListener("click", () => this.clearAll());
    this.downloadAll?.addEventListener("click", () => this.downloadAllAssets());
    this.backdrop?.addEventListener("click", () => this.closeModal());
    this.close?.addEventListener("click", () => this.closeModal());
    this.counterButton?.addEventListener("click", e => {
      this.listContainer.setAttribute('data-open', 'true');
      this.getDownloadList();
      document.body?.classList.add('mediacenter-opened');
    });
    this.header = document.querySelector('header');
    setInterval(() => {
      const assetDownloadList = parseInt(JSON.parse(getCookie('assetDownloadList') || "[]").length);
      if (assetDownloadList) {
        this.header.classList.add('has-donwload-list');
        const basketSize = parseInt(getCookie('basketSize') || "0");
        const lastSize = parseInt(getCookie('lastSize') || "0");
        this.counterAdded.innerHTML = this.formatBytes(basketSize, 0);
        this.counterBar.style.width = `${((basketSize / this.maxSize) * 100)}%`;
        this.counterBarLast.style.left = `${(((basketSize - lastSize) / this.maxSize) * 100)}%`;
        this.counterBarLast.style.width = `${((lastSize / this.maxSize) * 100)}%`;
        this.counter.innerText = assetDownloadList;
        this.$element?.querySelector('.basket-row')?.setAttribute('data-basket-show', 'true');
        this.basketShown = true;
      } else {
        this.header.classList.remove('has-donwload-list');
        this.counter.innerText = '';
        this.$element?.querySelector('.basket-row')?.setAttribute('data-basket-show', 'false');
        this.basketShown = false;
      }
      this.headerHandler();
    }, 1000);
    this.closeMessage();
    this.srcollDirection();

    const body = document.body;
    body ? body.classList.add('mediacenter') : null
  }

  private formatBytes(bytes, decimals = 2) {
    if (!+bytes || bytes < 0) return '0 Bytes'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }

  private srcollDirection() {
    let lastScrollTop = 0 as number, headerHeight = 0 as number;
    const header = document.querySelector('header.o-nav .m-nav-bar') as HTMLElement;
    const downloadist = document.querySelector('.o-download-list') as HTMLElement;
    if (header) headerHeight = header.clientHeight as number;
    if (header !== null) downloadist.style.top = `${headerHeight}px`;

    window.addEventListener("scroll", () => {
      if (downloadist) {
        const scrollPos = window.pageYOffset || document.documentElement.scrollTop as number;
        if (header) headerHeight = header.clientHeight as number;

        if (scrollPos > lastScrollTop) {// downscroll code
          if (header !== null) {
            if (scrollPos < headerHeight) downloadist.style.top = `${headerHeight - scrollPos}px`;
            else downloadist.style.top = `${0}px`;
          }

        } else if (scrollPos < lastScrollTop) {// upscroll code
          if (header !== null) {
            if (header?.classList.contains('uk-sticky-fixed')) downloadist.style.top = `${headerHeight}px`;
            if (!header?.classList.contains('uk-sticky-fixed') && (scrollPos < headerHeight)) downloadist.style.top = `${headerHeight - scrollPos > 0 ? headerHeight - scrollPos : 0}px`;
          }
        }
        lastScrollTop = scrollPos <= 0 ? 0 : scrollPos;
      }
    }, { capture: true });
  }

  private closeMessage() {
    const message = this.$element.querySelector('.message-row') as HTMLElement;
    const closeMessage = this.$element.querySelector('.message-close') as HTMLElement;
    closeMessage?.addEventListener('click', () => message?.setAttribute('data-show-message', 'false'));
  }

  private headerHandler() {
    const header = document.getElementsByTagName('header')?.[0] as HTMLElement;

    const body = document.body;
    const mediacenter = body?.classList.contains('mediacenter');
    const mediacenterDetail = body?.classList.contains('mediacenter-detail');

    if (header && header.classList.contains('overlap')) {
      if (this.basketShown) header.classList.add('black-background');
      else if (mediacenter && mediacenterDetail) header.classList.add('black-background');
      else header.classList.remove('black-background');
    }
  }
}
